import React from 'react';
import { PageHeader } from './PageHeader';
import { Footer } from './Footer';

/**
 * Shared page layout wrapper for public pages.
 *
 * Renders:
 *   • PageHeader (top bar + nav + mobile menu)
 *   • <main id="main-content"> with the page contents
 *   • Footer (with optional admin link)
 *
 * Includes a "skip to content" link for keyboard / screen-reader users.
 *
 * Props:
 *   children      — page contents (rendered inside <main>)
 *   showAdmin     — pass through to Footer (default false)
 *   skipToContent — show the skip link (default true)
 *   mainClassName — extra classes for the <main> element
 *   className     — extra classes for the outer wrapper
 */
export const Layout = ({
    children,
    showAdmin = false,
    skipToContent = true,
    mainClassName = '',
    className = 'min-h-screen flex flex-col overflow-x-hidden',
}) => {
    return (
        <div className={className}>
            {skipToContent && (
                <a
                    href="#main-content"
                    className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-gold focus:text-white focus:rounded-md"
                >
                    Skip to content
                </a>
            )}
            <PageHeader />
            <main id="main-content" className={`flex-1 ${mainClassName}`.trim()}>
                {children}
            </main>
            <Footer showAdmin={showAdmin} />
        </div>
    );
};

